// eslint-disable-next-line import/no-unresolved
import i18n from '@/i18n/i18n'
import TarfinProCampaignService from '@/services/admin/TarfinProCampaignService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  campaigns: [],
  campaign: {}
}

export const mutations = {
  SET_CAMPAIGNS(state, campaigns) {
    state.campaigns = campaigns.data
  },
  SET_CAMPAIGN(state, campaign) {
    state.campaign = campaign
  },
  ADD_CAMPAIGN(state, campaigns) {
    state.campaigns.push(campaigns)
  },
  REMOVE_CAMPAIGN(state, campaigns) {
    state.campaigns = state.campaigns.filter(campaign => campaign.id !== campaigns.id)
  },
  UPDATE_CAMPAIGN(state, params) {
    state.campaigns[params.value.id] = params.value
  }
}

export const actions = {
  getCampaigns({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      TarfinProCampaignService.getCampaigns()
        .then(response => {
          commit('SET_CAMPAIGNS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_campaign.campaigns')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTarfinProCampaign({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      TarfinProCampaignService.getCampaign(id)
        .then(response => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_campaign.campaigns')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createTarfinProCampaign({ commit, dispatch }, campaign) {
    return new Promise((resolve, reject) => {
      TarfinProCampaignService.createCampaign(campaign)
        .then(response => {
          commit('ADD_CAMPAIGN', campaign)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.save_error', {
                element: t('store.admin.tarfin_pro_campaign.campaigns')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeTarfinProCampaign({ commit, dispatch }, campaign) {
    return new Promise((resolve, reject) => {
      TarfinProCampaignService.updateCampaign(campaign.id, campaign)
        .then(response => {
          commit('REMOVE_CAMPAIGN', campaign)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.tarfin_pro_campaign.campaigns')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editTarfinProCampaign({ commit, dispatch, state }, campaign) {
    return new Promise((resolve, reject) => {
      TarfinProCampaignService.updateCampaign(state.campaign.id, campaign)
        .then(response => {
          commit('UPDATE_CAMPAIGN', { value: campaign })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.tarfin_pro_campaign.campaigns')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
